import axios from "axios";
import React, { useState } from "react";

import Breadcrumbs from "../../component/breadcrumbs";
import CustomHelmet from "../../component/CustomHelmet";
import Form from "../../component/Form";
import FormInput from "../../component/FormInput";
import Intro from "../../component/Intro";
import BaseContainer from "../../component/layout/base-container";

export default function RequestPasswordChange() {
  const [email, setEmail] = useState("");
  const [requested, setRequested] = useState(false);

  return (
    <>
      <CustomHelmet pageTitle="Passwort vergessen" />
      <Breadcrumbs
        listItems={[
          { name: "Home", url: "/" },
          { name: "Passwort vergessen", url: "/passwort" },
        ]}
      />
      <BaseContainer>
        <Intro title="Passwort vergessen?" />
        <Form>
          {requested ? (
            <>
              <div className="FormMessage">
                <div
                  className="FormMessage--inner js-Autofocus type-success"
                  role="alert"
                >
                  <div className="FormMessage--iconWrapper">
                    <span className="Icon" data-name="24--success">
                      <svg>
                        <use xlinkHref="#24--success"></use>
                      </svg>
                    </span>
                  </div>
                  <div className="FormMessage--body">
                    <div className="FormMessage--text richtext">
                      <p>
                        Wir haben Ihnen eine E-Mail zum Zurücksetzen gesendet.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <p></p>
            </>
          ) : (
            <>
              <p>
                Bitte geben Sie Ihre E-Mail-Adresse an, damit wir Ihnen einen
                Link zum Zurücksetzen Ihres Passwortes senden können.
              </p>
              <FormInput
                label="E-Mail-Adresse"
                type="email"
                value={email}
                required
                onInput={(e) => {
                  setEmail(e.target.value);
                }}
              />
              <div className="FormButtons">
                <button
                  disabled={!email}
                  className="Button color-primary size-large mb-8"
                  style={{
                    marginRight: "unset",
                    marginLeft: "auto",
                    ...(!email && {
                      backgroundColor: "rgba(var(--c-grey-light),1)",
                      color: "rgba(var(--c-black),0.6)",
                    }),
                  }}
                  onClick={async (event) => {
                    event.preventDefault();
                    await axios.post(
                      `${process.env.REACT_APP_BASE_URL}password_reset/`,
                      { email: email }
                    );
                    setRequested(true);
                  }}
                >
                  Passwort zurücksetzen
                </button>
              </div>
            </>
          )}
        </Form>
      </BaseContainer>
    </>
  );
}
